import React, { useState,useEffect,useContext, useRef } from 'react'
import { getItemVal,buildItemsList,getTlvLink } from '../../Data/GeneralFanction';
import { getAll } from '../../Data/Utils';
import './Footer.css'
import './FooterEn.css'
 import apple from '../../Images/Footer/apple.svg';
 import googleplay from '../../Images/Footer/google-play.svg'
 import digitel from '../../Images/Footer/digitelnew.svg';
 import assistive from '../../Images/Footer/icons-assistive-technology.svg';
 import map from '../../Images/Footer/icons-map.svg';
//  import { useTranslation } from "react-i18next";
 import Translate from '../Translate/Translate'
 import SocialFooter from '../SocialFooter/SocialFooter';
 import { LanguageContext } from '../../context';
 import  Button  from '@mui/material/Button';

 

const Footer = () => {

    const [footerData,setFooterData]=useState([]);
    const [showCustomerAgreement, setShowCustomerAgreement] = useState(false);
    const customerAgreementRef = useRef(null);
    const { language } = useContext(LanguageContext);

    useEffect(()=>{
        const getFooter = async () => {
            var webUrl=window.srcSiteUrl;
            if(language=="en")
                webUrl=webUrl+"/"+language;
            var apiUrl=config.apiUrl;
            //apiUrl=webUrl+apiUrl;
            const categoriesList=config.lists.footer.name; 
            //const selectedProps=config.lists.dataSet.selectProperties;
            let { data: footer } = await getAll(`${webUrl}${apiUrl}?listName=${categoriesList}`);
            var x=buildItemsList(footer);
            for (var i=0;i<x.length;i++){
                if(x[i].longURL.Value !== ''){
                    x[i].tlvLink = getTlvLink(x[i].longURL.Value);
                }


               
            }
            setFooterData(x) ;
        };
      var config = require('../../config.json');
      getFooter();       
      
      },[language]);

            const goTo=(divClass)=>{
                const divFocus = document.getElementsByClassName(divClass)[0];
                if (divFocus) {
                        divFocus.setAttribute('tabindex', '-1');
                        divFocus.focus();
                }
            }

                useEffect(() => {
                const isAccepted = sessionStorage.getItem('acceptCustomerAgreement');
                setShowCustomerAgreement(!isAccepted);
                }, []);

                useEffect(() => {
                if (!showCustomerAgreement) {
                    return;
                }

                const rafId = requestAnimationFrame(() => {
                    customerAgreementRef.current?.focus();
                });

                return () => cancelAnimationFrame(rafId);
                }, [showCustomerAgreement]);

      const acceptCustomerAgreement =(event)=>{
                sessionStorage.setItem('acceptCustomerAgreement', 'true');
                setShowCustomerAgreement(false);
                goTo('navigation-container');
      }

  return (

    <section className='foorterContainerAll' role="contentinfo" id="footerOuter" tabIndex="0">
 <div className='footerBottomALLDiv'>
  <div className="footer-new row"  role="contentinfo" >
     <div className="footer-top row">
      <div className="app-section col-xs-12 col-md-4">
        <h3><Translate>DigitelDownloadApp</Translate></h3>
        <ul>
            <li>
                <a href="https://play.google.com/store/apps/details?id=gov.telaviv.digitel.beach" target="_blank">
                    <img src={googleplay} alt="google-play" />
                </a>
            </li>
            <li>
                <a href="https://apps.apple.com/il/app/%D7%93%D7%99%D7%92%D7%99%D7%AA%D7%9C/id1422471711" target="_blank">
                    <img src={apple} alt="apple"/>
                </a>
            </li>
            <li>
                <img className='digitel'  src={digitel} alt=""/>
            </li>
        </ul>
    </div>

    <div className="col-xs-12 col-md-4 footerLinks" >
        <nav aria-label="ניווט תחתון" className="footerLinksNav" >          
            <ul className="row">
            {
                footerData.map((item,index)=>{
                    return   <li key={index}>
                                <a href={item.tlvLink.Url} target={item.tlvLink.Target}>{item.tlvLink.Caption}</a>
                            </li>
                })
            }
            </ul>  
        </nav>
    </div>

    <div  className="footerExtra col-xs-12 col-md-4">
        <SocialFooter/>
   

   <div className="left-buttons">
          <a className="gis" href="https://gisn.tel-aviv.gov.il/iview2js4/index.aspx" target="_blank">
              <div className="gis-btn"><img src={map} alt=""/><span><Translate>GisMapTitle</Translate> </span></div>
          </a>
          <a className="acessibility" href={`/${language}/accessibility`} target="_self">
              <div className="acessibility-btn"><img src={assistive} alt=""/><span><Translate>AccessibilityTitle</Translate></span></div>
          </a>
      </div>

  </div>
      </div>
	  
      </div>
	  <div className="footerBottomDiv">
      <div className="crossing-line col-md-12 hidden-sm hidden-xs "></div>
      <div className="footerBottom col-md-12 col-xs-12">

        <div className="footerLine">
		<div className="col-md-9 copyright">
             <span><Translate>Copyrights</Translate></span>
			 <br/>
            <span ><Translate>Copyrights1</Translate></span>
			</div>
			<div className="col-md-3 created-by">
            <span ><Translate>CreatedBy</Translate></span>
			</div>
        </div>
    </div>
	</div>
    </div>
     {showCustomerAgreement && <div className="customerAgreement" tabIndex="0" ref={customerAgreementRef}>
     <div className="customerAgreementText">
      <Translate>CustomerAgreementMain</Translate>
     <a href='/he/terms' target="_self"><Translate>CustomerAgreementTerms</Translate></a>
     <a href="https://www.tel-aviv.gov.il/About/Pages/PrivacyStatement.aspx" target="_blank"><Translate>CustomerAgreementPrivacy</Translate></a>
     </div>
     <Button className="customerAgreementButton"  onClick={acceptCustomerAgreement}><Translate>CustomerAgreementButton</Translate></Button>
 </div>}
</section>

  )
}

export default Footer